import { SmartImg } from "@/components/SmartImg";
import { CalendarCheck, Info, MessageCircle, ShieldCheck, Sparkles, HeartHandshake } from "lucide-react";
import { Button } from "@/components/ui/button";
import { waLink } from "@/lib/constants";

const PILLARS = [
  [HeartHandshake, "Atención integral"],
  [Sparkles, "Tecnología médica"],
  [ShieldCheck, "Confianza"],
];

export const Hero = ({ center, image, stock, framing, onOpen }) => {
  return (
    <section id="inicio" className="relative overflow-hidden bg-[#F5F7FA] pt-28 lg:pt-36" data-testid="hero-section">
      <div className="dot-grid absolute inset-0 opacity-60" />
      <div className="relative mx-auto grid max-w-7xl gap-14 px-5 pb-20 sm:px-8 lg:grid-cols-12 lg:gap-10 lg:pb-28">
        <div className="lg:col-span-6 lg:pt-6">
          <p className="reveal inline-flex items-center gap-2 rounded-full border border-[#1E6FD9]/15 bg-white px-3.5 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-[#1E6FD9]">
            <span className="h-1.5 w-1.5 rounded-full bg-[#14B8A6]" /> Salud con precisión
          </p>
          <h1 className="reveal mt-6 font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-[#0B2545] sm:text-5xl lg:text-6xl"
              style={{ animationDelay: "80ms" }} data-testid="hero-title">
            Centro Médico <span className="text-[#1E6FD9]">IEMED</span>
          </h1>
          <p className="reveal mt-6 max-w-lg text-base leading-relaxed text-slate-600 sm:text-lg" style={{ animationDelay: "160ms" }}
             data-testid="hero-message">
            Atención integral que combina tecnología médica avanzada con un trato humano y cercano. Tu salud, en manos de confianza.
          </p>
          <div className="reveal mt-9 flex flex-col gap-3 sm:flex-row sm:flex-wrap" style={{ animationDelay: "240ms" }}>
            <Button size="lg" onClick={() => onOpen("agendar")} className="h-12 rounded-full bg-[#1E6FD9] px-7 text-base shadow-[0_14px_30px_-12px_rgba(30,111,217,0.8)] hover:bg-[#0B2545]"
                    data-testid="hero-agendar-button">
              <CalendarCheck className="mr-2 h-5 w-5" /> Agendar una cita
            </Button>
            <Button size="lg" variant="outline" onClick={() => onOpen("info")} className="h-12 rounded-full border-slate-300 bg-white px-7 text-base text-[#0B2545] hover:border-[#1E6FD9] hover:text-[#1E6FD9]"
                    data-testid="hero-info-button">
              <Info className="mr-2 h-5 w-5" /> Solicitar información
            </Button>
            <Button size="lg" variant="ghost" asChild className="h-12 rounded-full px-5 text-base text-[#0B2545] hover:bg-[#14B8A6]/10 hover:text-[#0f8f81]">
              <a href={waLink(center.whatsapp)} target="_blank" rel="noopener noreferrer" data-testid="hero-whatsapp-button">
                <MessageCircle className="mr-2 h-5 w-5 text-[#14B8A6]" /> Hablar por WhatsApp
              </a>
            </Button>
          </div>
          <div className="reveal mt-12 flex flex-wrap gap-x-7 gap-y-3" style={{ animationDelay: "320ms" }}>
            {PILLARS.map(([Icon, label]) => (
              <span key={label} className="inline-flex items-center gap-2 text-sm font-medium text-slate-600">
                <Icon className="h-4 w-4 text-[#14B8A6]" /> {label}
              </span>
            ))}
          </div>
        </div>
        <div className="reveal relative lg:col-span-6" style={{ animationDelay: "200ms" }}>
          <div className="relative aspect-[4/3] overflow-hidden rounded-[2rem] bg-slate-200 shadow-[0_40px_80px_-40px_rgba(11,37,69,0.45)] lg:aspect-[5/4]">
            <SmartImg src={image} fallback={stock} alt="Equipo médico de Centro Médico IEMED" eager sizes="(min-width: 1024px) 50vw, 100vw"
                      framing={framing?.hero} mobileFraming={framing?.hero_mobile}
                      className="h-full w-full object-cover" testid="hero-image" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0B2545]/30 via-transparent to-transparent" />
          </div>
          <div className="absolute -top-4 right-4 hidden rounded-2xl bg-[#0B2545] px-4 py-3 text-white shadow-xl sm:block">
            <span className="block text-[11px] uppercase tracking-[0.18em] text-white/60">Atención</span>
            <span className="block font-display text-lg font-bold">Lun - Dom</span>
          </div>
        </div>
      </div>
    </section>
  );
};
